import React from "react";
import { Carousel, Button, Modal } from "react-bootstrap";
import DATA from "./openPositionsData";
import Header from "../header";
import ProjectDetails from "./ProjectDetails/ProjectDetails";
import SearchRolesYears from "./SearchRolesYears/SearchRolesYears";
import TechnologyTiles from "./TechnologyTiles/TechnologyTiles";
import FilteredResult from "./FilteredResult/FilteredResult";
import Footer from "../footer/Footer";
class OpenPositions extends React.Component {
  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.getButtons = this.getButtons.bind(this);
    this.filterProjects = this.filterProjects.bind(this);
    this.isActive = this.isActive.bind(this);
    this.setFilter = this.setFilter.bind(this);
    this.getProjectDetails = this.getProjectDetails.bind(this);
    this.splitClientsData = this.splitClientsData.bind(this);

    this.state = {
      show: false,
      projects: DATA.filter(function (data) {
        return true;
      }).map(function (data) {
        return data;
      }),
      selectedProject: {
        title: "",
        experience: "",
        education: "",
        workLocation: "",
        technologiesHeading: "",
        technologies: "",
        details: {},
        role: "",
      },
      filterButtons: [
        "All",
        "Node JS",
        "React JS",
        "HTML",
        "SQL",
        "Mongo DB",
        "Java",
      ],
      filteredRoles: [],
      category: "Roles",
      selectedButton: "All",
      click: false,
      currentYearsValue: 0,
      min: 0,
      max: 12,
      step: 1,
      sliderCurrentValue: 0,
      searchBarValue: "",
      noProjectsMessage: false,
      technologyTilesNumber: 10,
      details: false,
      width: 0,
      height: 0,
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow(project) {
    this.setState({ show: true, selectedProject: project });
  }

  setFilter(filter) {
    this.setState({ selectedButton: filter });
  }

  isActive(value) {
    let activeValue = "";
    if (value === this.state.selectedButton) {
      activeValue = "active";
    }
    return activeValue;
  }

  filterProjects() {
    this.setState({ projects: {} });
    let filterProjects = [];
    if (this.state.selectedButton !== "All") {
      this.setState({ click: true });
      this.state.selectedButton
        .trim()
        .split(" ")
        .map((value) => {
          filterProjects = DATA.filter((data) => {
            if (data.technologies.toLowerCase().includes(value.toLowerCase())) {
              return data;
            }
          });
        });
    } else {
      this.setState({ click: false });
      filterProjects = DATA.filter(function (data) {
        return true;
      }).map(function (data) {
        return data;
      });
    }
    if (this.state.searchBarValue.trim() !== "") {
      this.setState({ click: true });
      let filteredBySearch = [];
      this.state.searchBarValue
        .trim()
        .split(" ")
        .map((value) => {
          filteredBySearch = filterProjects.filter((data) => {
            if (isNaN(value)) {
              if (
                data.technologies.toLowerCase().includes(value.toLowerCase())
              ) {
                return data;
              } else if (
                data.title.toLowerCase().includes(value.toLowerCase())
              ) {
                return data;
              }
            } else {
              if (
                data.experienceYearsRange.length > 1 &&
                value >= data.experienceYearsRange[0] &&
                value <= data.experienceYearsRange[1]
              ) {
                return data;
              } else if (value >= data.experienceYearsRange[0]) {
                return data;
              }
            }
          });
          filterProjects = filteredBySearch;
        });
    }

    if (this.state.currentYearsValue > 0) {
      this.setState({ click: true });
      filterProjects = filterProjects.filter((data) => {
        if (
          data.experienceYearsRange.length > 1 &&
          this.state.currentYearsValue >= data.experienceYearsRange[0] &&
          this.state.currentYearsValue <= data.experienceYearsRange[1]
        ) {
          return data;
        } else if (
          this.state.currentYearsValue >= data.experienceYearsRange[0]
        ) {
          return data;
        }
      });
    }
    let noProjMsg = filterProjects.length > 0 ? false : true;
    this.setState({ noProjectsMessage: noProjMsg });

    if (filterProjects.length > 0 && filterProjects.length < 8) {
      for (let x = filterProjects.length; x < 8; x++) {
        filterProjects[x] = {};
      }
    }
    this.setState({ projects: filterProjects });
  }

  splitClientsData(num) {
    const projects = [];
    let items;
    let start = 0;
    let i = 1;
    for (i = 1; i < this.state.projects.length / num + 1; i++) {
      items = this.getItemsForSlides(start, num, i);
      start = num * i;
      projects[i] = items;
    }
    return projects;
  }

  getItemsForSlides(start, num, i) {
    let items = this.state.projects
      .slice(start, num * i)
      .map((project, index) => {
        return this.getProjectDetails(
          project,
          index,
          "projectDetailsContainer"
        );
      });
    return items;
  }

  getProjectDetails = (project, index, marginClassName) => {
    return (
      <ProjectDetails
        handleShow={this.handleShow}
        key={index}
        project={project}
        index={index}
        marginClassName={marginClassName}
      />
    );
  };

  filterRolesTechnology(role, lastIndexValue) {
    let technologiesString = "";
    DATA.filter((data) => {
      if (data.role.toLowerCase().includes(role.toLowerCase())) {
        technologiesString = technologiesString + data.technologies + ",";
      }
    });
    let occurancesArray = [];
    technologiesString.split(",").map((tech, index) => {
      if (tech !== "") {
        const alreadyCounted = occurancesArray.map((c) => c.name);
        if (alreadyCounted.includes(tech)) {
          occurancesArray[alreadyCounted.indexOf(tech)].count += 1;
        } else {
          occurancesArray.push({ name: tech, count: 1 });
        }
      }
    });
    occurancesArray.sort((a, b) => b.count - a.count);
    let finalArray = ["All"];
    if (lastIndexValue > occurancesArray.length) {
      lastIndexValue = occurancesArray.length;
    }
    for (let index = 0; index < lastIndexValue; index++) {
      finalArray.push(occurancesArray[index].name);
    }
    lastIndexValue !== occurancesArray.length && finalArray.push("...");
    return finalArray;
  }

  getButtons(button) {
    let filteredTiles = this.filterRolesTechnology(button, 10);
    this.setState({
      filterButtons: filteredTiles,
      technologyTilesNumber: 10,
      category: button,
      projects: DATA,
      selectedButton: "All",
    });
  }
  updateDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
    this.getRoles();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  getRoles() {
    let filteredRolesArray = DATA.map((data) => {
      return data.role.toLowerCase();
    });
    let uniqueRoles = filteredRolesArray.filter((item, index) => {
      return filteredRolesArray.indexOf(item) === index;
    });
    this.setState({ filteredRoles: uniqueRoles });
  }

  changeValueOfSliderHandler = async (event) => {
    await this.setState({ currentYearsValue: event.target.value });
    this.filterProjects();
  };

  searchClickHandler = async (event) => {
    await this.setState({ searchBarValue: event.target.value });
    this.filterProjects();
  };

  rolesFilterHandler = (buttonClicked) => {
    if (buttonClicked === "...") {
      this.setState({ selectedButton: "" }, () => this.showMore());
    } else {
      this.setState({ selectedButton: buttonClicked }, () =>
        this.filterProjects()
      );
    }
  };

  showMore = () => {
    let tilesNumber = this.state.technologyTilesNumber + 10;
    let filteredTiles = this.filterRolesTechnology(
      this.state.category.toLowerCase(),
      tilesNumber
    );
    this.setState({
      filterButtons: filteredTiles,
      selectedButton: "All",
      technologyTilesNumber: tilesNumber,
    });
  };

  render() {
    return (
      <div>
        <Header />
        <div
          id="openPositions"
          className="section translucent-bg bg-image-1 pb-clear blue openPositions-container"
        >
          <div className="container-fluid">
            <h1 className="title text-center openPositions-margin">
              Open Positions
            </h1>
            <div className="scrl">
              <div className="container-fluid">
                <SearchRolesYears
                  onChangeSearchBar={this.searchClickHandler}
                  searchBarValue={this.state.searchBarValue}
                  onClickOfRoles={this.getButtons}
                  category={this.state.category}
                  filteredRoles={this.state.filteredRoles}
                  currentYearsValue={this.state.currentYearsValue}
                  onClickSlideStop={this.changeValueOfSliderHandler}
                  step={this.state.step}
                  max={this.state.max}
                  min={this.state.min}
                />
                <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                  <div className="tab-content">
                    <TechnologyTiles
                      filterButtons={this.state.filterButtons}
                      isActive={this.isActive}
                      setFilter={this.setFilter}
                      rolesFilterHandler={this.rolesFilterHandler}
                    />
                    <FilteredResult
                      click={this.state.click}
                      noProjectsMessage={this.state.noProjectsMessage}
                      projects={this.state.projects}
                      getProjectDetails={this.getProjectDetails}
                      show={this.state.show}
                      handleClose={this.handleClose}
                      selectedProject={this.state.selectedProject}
                      selectedButton={this.state.selectedButton}
                      splitClientsData={this.splitClientsData}
                      width={this.state.width}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default OpenPositions;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/careers/OpenPositions.js